import {ThemeProvider} from "@mui/material";
import Body from "./reusables/Body.jsx";
import APXTheme from "./reusables/js/APXTheme.js";


export default function App() {
	  return (
				 <>
						<ThemeProvider theme={APXTheme}>
							  <Body/>
						</ThemeProvider>
				 </>
	  );
}

